import React from 'react'
import { AutoDrive } from './buttons/AutoDrive'
import { FrenoMano } from './buttons/FrenoMano'

export const ZonacentralBottonCentral = () => {
  return (
    <div className='zone-bttn-central'>
          <FrenoMano />
          <AutoDrive />
          </div>
  )
}
